enum ValidationEndpoints {
  VerifyEmail = '/account-ms/v1/ms/validation/verifyEmail',
  VerifyMobile = '/account-ms/v1/ms/validation/verifyMobile',
  VerifyDocument = '/account-ms/v1/ms/validation/verifyDocument',
}

export default ValidationEndpoints;
